module.exports = __webpack_public_path__ + "warning.6337ff62.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/warning.png
// module id = 515
// module chunks = 0